import { InputValidationComponent } from 'core/validation/input/input-validation.component'
import { FormValidationComponent } from 'core/validation/form/form-validation.component'
import { constraints } from './pbm-seven.constraints'
import { PbmSevenCadastroMask } from './pbm-seven-cadastro.mask'
import { PbmSevenComponent } from './pbm-seven.component'
import { PbmSevenService } from './pbm-seven.service'
import { Message } from 'components/message'
import { CepComponent } from './cep/cep.component'
import { Observable } from 'rxjs'

export class PbmSevenCadastroComponent {
  constructor(data) {
    this.data = data;
    this.formElement = document.querySelector("#pbm-form-seven-cadastro");
    this.service;
    this.masks;
    this.validator;
    this.inputValidator;
    this.cepComponent;
    this.ativaDesconto = document.querySelectorAll('.ativa-desconto')
    this.compraComDesconto = document.querySelectorAll('.compra-com-desconto');
    this.alert = new Message();

    this.init();
  }

  init() {
    if (this.formElement) {
      const cadastroForm = this.formElement.querySelector('[data-step="' + this.data.cadastro.toUpperCase() + '"]')

      //cep autocomplete component
      this.cepComponent = new CepComponent(cadastroForm);

      //form validation
      this.validator = new FormValidationComponent(cadastroForm, constraints[this.data.cadastro.toLowerCase()])

      //input validation
      this.inputValidator = new InputValidationComponent(cadastroForm, constraints[this.data.cadastro]).init()

      //masks
      this.masks = new PbmSevenCadastroMask(cadastroForm);

      //service
      this.service = new PbmSevenService();

      //hide cadastro
      Array.prototype.forEach.call(this.formElement.querySelectorAll('.seven-cadastro'), form => {
        form.style.display = "none"
      })

      //show cadastro for step
      if (cadastroForm)
        cadastroForm.style.display = "block"

      //submit event
      Observable
        .fromEvent(this.formElement, 'submit')
        .do(event => event.preventDefault())
        .filter(() => {
          if (cadastroForm.querySelector('#consumidorCep').value != "" && cadastroForm.querySelector('#consumidorCidade').value == "") {
            return false
          }
          return true
        })
        .filter(() => this.validator.validateForm())
        .map(event => this.validator.serializeForm())
        .subscribe(formData => this.buildCadastroformData(formData))
    }
  }

  buildCadastroformData(formData) {
    this.data.pbm.cadastroFormData = formData;
    this.data.pbm.cadastro = this.data.cadastro;
    this.data.pbm.preautorizacao = this.data.preautorizacao;
    this.data.pbm.ativa = true;
    this.data.pbm.ativar = true;

    return this.service.ativa(this.data.pbm).subscribe(this.cadastroResponse())
  }


  cadastroResponse() {

    return {

        next: response => {

          if(response.status == 200){

              let pbmSevenComponent = new PbmSevenComponent(this.data.pbm)

          }else{
            this.alert.message = "Erro ao validar desconto PBM, tente novamente!";
            this.alert.show();
          }
        },
        error: error => {

          let msg = "Verifique seus dados e tente novamente";
          if(error) {
            if(error.status) {
              if((error.status == 400 || error.status == 404) && error.data && Array.isArray(error.data)){
                msg = error.data.map((elem) => elem.message).join(", ")
              }else if((error.status == 400 || error.status == 404) && error.data && error.data.mensagem){
                msg = error.data.mensagem;
              }

              if(!error.data) msg = "Não foi possível autorizar este item"
            }
          }

          this.alert.message = msg;
          this.alert.show();
        },

    }
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-seven/pbm-seven-cadastro.component.js